import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/9dff789/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The login page allows a user to gain access to an application by entering their user ID and password.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Overview</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Behavior</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Design types</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Accessibility</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Related</AnchorLink>
      <AnchorLink mdxType="AnchorLink">References</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`This pattern covers the user ID and password screens seen by users as they log in to IBM products. Federated and non-federated authentication are included in this pattern. Error states, forgot username/password, and additional authentication methods will be covered in future iterations of this pattern.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Term`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Definition`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Federated users`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IBM employees and other enterprise users who use single sign-on (SSO) to quickly log in.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Non-federated users`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Other users who have a unique username and password to access the product.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Single sign-on (SSO)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Directs users to their company’s enterprise sign on and authenticates them using their company credentials.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "anatomy"
    }}>{`Anatomy`}</h3>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.28571428571428%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABjElEQVQ4y62TPU/DMBCG+1M7tX+FpR3aTvwBlgqJgZUFMbCDGCqkfickaf3tOCT1yzmh0EIlJFRLb84X3z26uzgtnHm1wqPX66HdbqPb7aLT6fxbk8mkAY7HY/T7fYxGIwyDhkMMBoPaHiq82+vnWdBqtULLe3/elgNQSQkmONgsxuZ5BqkkNlmGLE0RxxGSJEGWpfC7HeAreL+DsRaMMbAtibN6X5ZlAzTGQGoFuc4gJmto8jNGCdKBqwLSvMPkJdkK620FZysUxoJP3+p4lVO+kCeA6RZymVKFCilVJXlGgVuCNmAmCyS8gCs8CucgGIfiAoripfwJNBoiwF4W1ILC+EHh6t7h+rGEds18DsftCBggARZG9hsYKow3UNOIKslxeQdc3NCVugWECSSPELv/iEfAkxV+AsVrBGsNpVhSsDl0TjHuG/o3UGtqWUHME/CnOYQQWEcxlhHDPNJYxAbJRkPrb+0hh/oC5nleV2k0Sep6XyeRr7StrQ5n5liWrs5ewa+qqvlTzrk+AFyXvR6xB407AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Anatomy of a login page",
            "title": "Anatomy of a login page",
            "src": "/static/92fb52a333bc668fa5286d21b87bf295/c801a/Login_anatomy.png",
            "srcSet": ["/static/92fb52a333bc668fa5286d21b87bf295/1a057/Login_anatomy.png 288w", "/static/92fb52a333bc668fa5286d21b87bf295/8418d/Login_anatomy.png 576w", "/static/92fb52a333bc668fa5286d21b87bf295/c801a/Login_anatomy.png 1152w", "/static/92fb52a333bc668fa5286d21b87bf295/4d515/Login_anatomy.png 1728w", "/static/92fb52a333bc668fa5286d21b87bf295/66720/Login_anatomy.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Title:`}</strong>{` Log in to IBM `}{`[Product name]`}{`.`}</li>
      <li parentName="ol"><strong parentName="li">{`User ID:`}</strong>{` User IDs are usually in the form of an email address. Depending on the product, this area may also include a filter to specify the ID type.`}</li>
      <li parentName="ol"><strong parentName="li">{`Forgot user ID?:`}</strong>{` Help link specifically for user ID questions and issues.`}</li>
      <li parentName="ol"><strong parentName="li">{`Remember me option`}</strong>{`: Saves the user ID and presents the completed input field the next time the user logs in.`}</li>
      <li parentName="ol"><strong parentName="li">{`Continue button`}</strong>{`: The primary call to action. When clicked, the email address is validated and routes the user to either the federated or non-federated flow.`}</li>
      <li parentName="ol"><strong parentName="li">{`Create account option:`}</strong>{` Link to URX form to create an account.`}</li>
      <li parentName="ol"><strong parentName="li">{`Need help?:`}</strong>{` Help link specifically for user ID questions and issues.`}</li>
    </ol>
    <h3 {...{
      "id": "when-to-use"
    }}>{`When to use`}</h3>
    <p>{`The login page is presented to users in the following scenarios:`}</p>
    <ul>
      <li parentName="ul">{`When a user wants to gain access to an app.`}</li>
      <li parentName="ul">{`When a user has logged out voluntarily. They will see a confirmation message after which they will be automatically redirected back to the login page.`}</li>
      <li parentName="ul">{`When a user has been logged out due to inactivity. In this scenario, when the user logs back in they should be redirected to the last page they were on, before being logged out.`}</li>
    </ul>
    <h2 {...{
      "id": "behavior"
    }}>{`Behavior`}</h2>
    <p>{`Federated users log in with SSO (single sign-on) and non-federated users are required to provide both their user ID and password. Separate the user ID and password fields into different flows to easily accommodate both federated and non-federated users.`}</p>
    <p>{`IBM uses multi-factor login for products. The user ID should be requested upfront with a “Continue” button to move forward. This allows the system to distinguish which path the user needs to take in the background instead of making the user read through options and choose. The system validates the username and provides a field for the password only if required.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.72826086956522%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACLElEQVQoz22Sy04TcRSH51F8B7dufQc3btSggkgMGBM3Gg14wZCYABpRcUOMUTZiIo0hooAgNHIvLa1AbzO9DS2M9DKdOZ+nFHDjSb6c/2TO+eXcjMVYnaWYy/Jvl5Utl/lIjclVl5l1l7mNGsHNqv6rEtqpEklUydplHo16nOuFS/1CyyBcH4KOl3DjNRjBqE8w6rEQqbO2o8RheRv1QiQNUVPYyvgk8kqujr1X492UT/d7eDom9HyAay9U7BV0NgRnw8K8is6EPE3w2N/bpVgs4jgOlmVh2zalUolCoYDrujRMRPCVhkVSwmWtsnMYuhTj+7owGxEm10Sr8SnkTLK5nIoUMdNp8vrOZjIqblI/ElTJEx9OwZVncPNNE2NiFaZCwscghJI+9XrtMPw45Ti9gefDn4qQtAWr2IwIJ4Wrg8Itra6BMb4kjC8KI9PC0g7EEjbrUZNQLKNYh99m/oC0YubL6svEMwdsWdWTltsGhC5dTFu/Co4Fhbc/hOFvsLBZIZVMsFvax94t6Sz3cMouTsXTypTykVecst+sMCFc7NUq+3SWTwRjZBqGvooCwViNuFkknq2SyldI5mtUXf5rzZ0IIb2I8/eFVhVrVWGjPwADX+D5hBBYgbM9cOYOnL4Np9ph9GdzgnVPDrd7jOc3Z7ixLVy4B+2PteWH2nLvJ72ngND3GeZiumlLWNYbXNFWfmmw7cjJqYj8W5V/JBjWmJa7QscDob1b+Avwr84PFpsFMgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "User ID input field",
            "title": "User ID input field",
            "src": "/static/7e2e789d0eac6ed27d383e1c333f42dc/c801a/IBMid_field.png",
            "srcSet": ["/static/7e2e789d0eac6ed27d383e1c333f42dc/1a057/IBMid_field.png 288w", "/static/7e2e789d0eac6ed27d383e1c333f42dc/8418d/IBMid_field.png 576w", "/static/7e2e789d0eac6ed27d383e1c333f42dc/c801a/IBMid_field.png 1152w", "/static/7e2e789d0eac6ed27d383e1c333f42dc/7d33b/IBMid_field.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Step 1 of the login flow for both federated and non-federated users
        </Caption>
      </Column>
    </Row>
    <p>{`From this point, the user will either continue to their company’s SSO login experience or they’ll see a password field and a “Log in” button. The password page should include a way to return to the prior page in case they make a mistake while filling out their user ID and a “Forgot password” button. When users enter their authentication information progressively, the cognitive load is reduced.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.72826086956522%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACN0lEQVQoz32SbUuTYRTH91H6DH2KPkKvelH0pImaJCUoWkNFpcISsieCoAgzK60krdCSTNREW3vIOZ3bbru3uemcbvfD+XW2qdGbDvzhuuG+ftf/nP/xTPqEKb8qILyaEQamXIamHYZnHN7N2owvWEwuWUz7LeZCRSJGgY4Bh+M9cLpPOH8H6h9Aw0O49Ag844sw4YOROWFsCaZD8MUPX4MwG4b5FVhcBX8MgjGHeNLi6YRL+wD0jgidz6H2rsIU2KjyjH4X3qoef4afMZf89iabmQy5XA7DMEin02SzWVKpFJZlUSoRwVWVKhQTqm+rw36o6lXg61nhyZRw/xP8iLqkkwlM01RIhkQiTlLPGxuGwhPY+0BF7gsCUeFkl3DuunC2R/CUnN37KPR/gIVVVy8VsOyD3/8t24XfW0IsLZhbFbAvAieuqUuFVXUrsHcU+saEW+91dhpMzMgQCJssr6UJRZL8WlVFzLLCayni5h7L0SyBSK78iD8inLoKNV1woVNb7hqGm6PCDQVP+nYx4lEy2ZzOcUvb3mYnX2R7xyorl7fJ7zns7Nr67VRaVuCZVqGuQ6jxqkPvEHS/0bRGSg6LRBMZomaBdXWynixSsPhPCcEVXZ1ml3qvS22bi6dFY/e+hPZh3cN5OKa2j16p6EgNDH6rBGA7Uk73QI5bmXIwrLNrcrjY5lDb4uC5/AxaXwjNg7qPOsNlQzQcYXFNmNd20jk5XBWRv1G5h0CX6kabhmabuiaLPwANxfgTpPjMAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBMid input field",
            "title": "IBMid input field",
            "src": "/static/13e9bfaae7fb0fea3f009ad1df4f599c/c801a/Login_password_field.png",
            "srcSet": ["/static/13e9bfaae7fb0fea3f009ad1df4f599c/1a057/Login_password_field.png 288w", "/static/13e9bfaae7fb0fea3f009ad1df4f599c/8418d/Login_password_field.png 576w", "/static/13e9bfaae7fb0fea3f009ad1df4f599c/c801a/Login_password_field.png 1152w", "/static/13e9bfaae7fb0fea3f009ad1df4f599c/7d33b/Login_password_field.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Step 2 of the login flow for non-federated users</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "design-types"
    }}>{`Design types`}</h2>
    <p>{`The Login page should focus on the main task of accessing one’s account. The point of this page is to get the user into their account quickly without complicating the workflow. It’s not recommended to include anything that will create too much of a distraction from the form.`}</p>
    <p>{`Simple illustrations can add personality and help differentiate the form from other products, but they should not pull the user’s focus away from logging in. Consider the simplest approach to logging in to an account on mobile and maintain that simplicity on tablet and desktop.`}</p>
    <p>{`There are two design options for login pages—the single-column layout and the split-screen layout.`}</p>
    <h3 {...{
      "id": "single-column-layout"
    }}>{`Single-column layout`}</h3>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.28571428571428%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABTklEQVQ4y62TsW7CMBCGeVQmeJUuZIBMfYEuUaUOXbtUHfoMbG0hUQgxdmzHIcF/zw6GULUSqrD05y4+/5/OjjPCjcfIPWazGcbjMabTKSaTyb+1XC57YJIkiKIIcRxjsVh4zefzUz6cC/pZc1qtVhhZa2+7ZQesqgqMsZOEENgWBYpigyxLkee5z+3hANjOR6UUWFle+Nq27YGu6CAO7KKk94JpMGGwqxoItYeqW4od1mULswf2jQE/eoLvV6AvkjbUldhtIXhJ0B7MRIOcNQS01wGFqCDd9rlE8lbh4dXg8b2FNP35DI/bGHPZxN9AQZ1o3L8Ad090pZ4BrhzJwq0NH/EqYChorciiSS7WkDWtMWfoVUDO+bFLQbnAOs3wlTJ8pBKfmUK+lZDyrAAZ6gSs69pDtdZeLvcmqUjaR0ly80OF9cHTdV3/p9xyfAPES771toclsAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Single column layout login page",
            "title": "Single column layout login page",
            "src": "/static/fc93043af703fe1ac3aadd0c9c2d1972/c801a/single_Col_login.png",
            "srcSet": ["/static/fc93043af703fe1ac3aadd0c9c2d1972/1a057/single_Col_login.png 288w", "/static/fc93043af703fe1ac3aadd0c9c2d1972/8418d/single_Col_login.png 576w", "/static/fc93043af703fe1ac3aadd0c9c2d1972/c801a/single_Col_login.png 1152w", "/static/fc93043af703fe1ac3aadd0c9c2d1972/4d515/single_Col_login.png 1728w", "/static/fc93043af703fe1ac3aadd0c9c2d1972/66720/single_Col_login.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Single column layout login page</Caption>
      </Column>
    </Row>
    <p>{`Use the single-column login form for a simple entry point for users. Without any distractions on the page, users can focus on their primary goal of signing in to the application or product. Through navigating to the login page, users have already shown intent to log in so additional content about the product isn’t necessary.`}</p>
    <h3 {...{
      "id": "split-screen-layout"
    }}>{`Split-screen layout`}</h3>
    <p>{`The split-screen page is an alternate design that can be used to include some marketing content or other visual treatment related to the product. The login portion of this layout uses the same design and behavior as the single-column layout but is confined to one part of the page.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.28571428571428%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACCklEQVQ4y62SS48SQRSF+a8MDStWLlmrMSEw0GrcSPwHunXh1jFmjBgzDnF0GAZouukX9ewBuo+3unkns7OS0/W4t746t6tK+M+ttFwu0Wg0UC6XUavVUK1WYVkWKhUr709VtSrUV/ZrVQtnZ2XU63W4rovSarVCr9dDs9lEq9VCu92G3e3Ctm10qd/KtrsUs/H8hY2nz17i/NxGp1OstVsdvH71BlEYoWRsGqiUMpfWGtkj5aQUcOaATvZrWXowpngpoy9jHEJqSJVAKY0gVnADgTiKEG0U0un30xhffzAEQTH3vBjzeQyfFPgx1ut14TDyZ0jYDKn2kchF7lRJQQcxcM4QLzjCiGM257jo02Eeh0fjuU/rIaeDeW4qTXNgho/fOJ68U6i/1fjUF1glBsLyJAM0sCAqoJdXCn5YALYyOZzzrcMM1yOJDxcC7z8LDEYCWrKjZAPzAgLGHMOJwNihHMUOoEdA5Lczc1woFuwSDWjnkEATKjOi3pQ/uJXwqFzB2cbdiUPPX+B2HGHqydyNCRoVQA4pGFy/mD9ohjty+X0g4ZNrozjme6C5ZSHExtFeZu4Q5Bf9gqHD8fte4GbMMaLxzxuB0dTAWO40CIs9O6BSqrjZTS+lotIlhq7G5Z8Efx2Nq7sEX64f0Dfziab3SM8rUmB8vzdN0+IfPtay3QvPDnQaO27/AJahtZumi4DjAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Login with visual imagery",
            "title": "Login with visual imagery",
            "src": "/static/2aaa61fdc838d3be31ce362825871de2/c801a/Login_with_graphic.png",
            "srcSet": ["/static/2aaa61fdc838d3be31ce362825871de2/1a057/Login_with_graphic.png 288w", "/static/2aaa61fdc838d3be31ce362825871de2/8418d/Login_with_graphic.png 576w", "/static/2aaa61fdc838d3be31ce362825871de2/c801a/Login_with_graphic.png 1152w", "/static/2aaa61fdc838d3be31ce362825871de2/4d515/Login_with_graphic.png 1728w", "/static/2aaa61fdc838d3be31ce362825871de2/66720/Login_with_graphic.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a split-screen login page with product-related visual imagery
        </Caption>
      </Column>
    </Row>
    <p>{`Any additional content on this page should be minimal and easy to scan. It shouldn’t distract from the login form. The user’s primary goal is logging in and that should be reflected in the visual design and emphasis on the page.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.28571428571428%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACfUlEQVQ4y62Ty0tUURzHD5SPcXyGRo8xu75NfCxEzcKgFlpJQlCLKCrHGUOdybF01B4+QKMgslqUuJkKN22NFu37B8okCUJRtGY0HXUc587j05lRqaGCgi58OPfA/X3O93d+XMF/foSqqgz092E2NdJqMYewtJgk5jAaGozU19djMBjCMBqN6PV6TCYTdrsd4Vpzo8utQWwvQMQUIzSFcpXvmnxJHiIyi23aPHr77vD8mY3h4eFfGBoawmaz4XQ6g0IPSpmVuIwrpBxoJD69DpF0GpFwSiIPiq9Gu6eWmdnFv2s5KNxf2oZS2kp+ZTuHTt6irKqDg1VWio9cJUk5S9TOGt6PT+J2r7G84sLr8+NRvagSl9vL0qoXr9dLIBDYTFh+A21mE4k5TSTLlOmlFrLLW8goaSZGdwZNqoGxCTvfnG4+TzuYnFlg1rGKfdHDjGOdKbsH1ReQ+YJCtxRW9BCbYyG1xEpirpQoBrRKPRF7ziGSzxOb1c278TkWFpeZkq1/mV9lXfWFEvn9gdC6hVhzqyiH+0kq6CSlqANNhplopRGN0iDFUpp2E232AOMTc7x4C3VPQT8EH6Y37swf2FjDhOmVd9lRdBtdWS8pxV3E510jLruZpPweorPuE5t7j7GPX/HLwnmnyrLLJ+8xPFmYMPPoIFpZnFDYTWSmlcgMi8SKJvcxUVmDMv1Dxj855ABU5uyreDzesFRhwuBHuyseIHZ1IvZ1IXTtiL3XEWmDCOWJ3A8SkflIDsURmu7Sig/XOvg2e93s+Idw3ePjQtsoxy6OcLxuhKpLNqovv+SE/o3ktdyPUmt4JSe7tFUZ0vwuXUj4L//pnyQ/8x0aHQiLhOeXAgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Login with marketing content",
            "title": "Login with marketing content",
            "src": "/static/f3a08760ebfc082c1a0ab0438a856b44/c801a/Login_marketing_material.png",
            "srcSet": ["/static/f3a08760ebfc082c1a0ab0438a856b44/1a057/Login_marketing_material.png 288w", "/static/f3a08760ebfc082c1a0ab0438a856b44/8418d/Login_marketing_material.png 576w", "/static/f3a08760ebfc082c1a0ab0438a856b44/c801a/Login_marketing_material.png 1152w", "/static/f3a08760ebfc082c1a0ab0438a856b44/4d515/Login_marketing_material.png 1728w", "/static/f3a08760ebfc082c1a0ab0438a856b44/66720/Login_marketing_material.png 2240w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a split-screen login page with marketing content</Caption>
      </Column>
    </Row>
    <p>{`There may be a need to include some marketing content on this page. When including additional content, be sure to keep the marketing and login content separated. Testing has shown that users don’t look outside of the login region to find related actions such as create account or SSO buttons, and often miss those actions if they are embedded in the marketing content.`}</p>
    <h3 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h3>
    <h4 {...{
      "id": "do"
    }}>{`Do:`}</h4>
    <ul>
      <li parentName="ul">{`Use the phrase Log in, not Sign in. This is to make it visually distinct from Sign up. They’re often side by side and the different words allow for quick distinction between the two options.`}</li>
      <li parentName="ul">{`Use Log in to `}{`[Product name]`}{`, with Log in as two words.`}</li>
      <li parentName="ul">{`Let users log in quickly. Keep the login page uncluttered to reduce cognitive and visual loads.`}</li>
      <li parentName="ul">{`Use a clear call to action, that is correctly sized. This reduces the motor load or physical effort it takes to perform the action.`}</li>
      <li parentName="ul">{`If you’re using a split-screen design, include a clear division between the content on each side—marketing copy or visual imagery on one side, login details on the other. Do not mix the two.`}</li>
      <li parentName="ul">{`Include forgot password and forgot ID buttons near each of their respective text fields, rather than including them both on each page.`}</li>
      <li parentName="ul">{`Offer to remember the login information to speed up logging in next time.`}</li>
      <li parentName="ul">{`Put simple sign up links with the login content, not the marketing content.`}</li>
    </ul>
    <h4 {...{
      "id": "dont"
    }}>{`Don’t:`}</h4>
    <ul>
      <li parentName="ul">{`Don’t make users sign in until it’s necessary.`}</li>
      <li parentName="ul">{`Don’t present options to “Log in using SSO” or “Log in using User ID.” Have the system do the work for the user by authenticating information progressively.`}</li>
      <li parentName="ul">{`Don’t remove fields abruptly. For example, don’t show a password field upfront and then hide it when the system recognizes that the email is associated with a federated account.`}</li>
    </ul>
    <h2 {...{
      "id": "accessibility"
    }}>{`Accessibility`}</h2>
    <p>{`Ensure that users can tab through the login form and navigate the page using only a keyboard. Use landmark regions to designate the login region and allow screen readers to skip directly to the input fields. This is especially important if you are using the split-screen layout or have additional content on the page.`}</p>
    <h2 {...{
      "id": "related"
    }}>{`Related`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/button/code"
        }}>{`Button`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/dropdown/code"
        }}>{`Dropdown`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/link/code"
        }}>{`Link`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.carbondesignsystem.com/components/text-input/code"
        }}>{`Text input`}</a></li>
    </ul>
    <h2 {...{
      "id": "references"
    }}>{`References`}</h2>
    <ul>
      <li parentName="ul">{`Raluca Budiu, `}<a parentName="li" {...{
          "href": "https://www.nngroup.com/articles/login-walls/"
        }}>{`Login Walls Stop Users in Their Tracks`}</a>{` (Nielsen Norman Group, 2014)`}</li>
      <li parentName="ul">{`Lee Munroe, `}<a parentName="li" {...{
          "href": "https://www.leemunroe.com/login-vs-signin/"
        }}>{`Login vs Sign in`}</a>{`, (2010)`}</li>
      <li parentName="ul">{`W3C, `}<a parentName="li" {...{
          "href": "https://www.w3.org/TR/WCAG20-TECHS/ARIA11.html"
        }}>{`Using AIRA landmarks to identify regions of a page`}</a></li>
      <li parentName="ul">{`Susan M. Weinschenk, Ph.D., 100 Things Every Designer Needs to Know about People (New Riders, 2011)`}</li>
    </ul>
    <h2 {...{
      "id": "feedback"
    }}>{`Feedback`}</h2>
    <p>{`Help us improve this pattern by providing feedback, asking questions, and leaving any other comments on `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-website/issues/new?assignees=&labels=feedback&template=feedback.md"
      }}>{`GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      